export default "__VITE_ASSET__ahvEkdz8__"